import routes from "./routes";
import firebase from "./firebase";
const Configs = {
  routes,
  firebase,
};

export default Configs;
